import React from "react";
import ProductionAndSalesWithPaymentsGenericSkeleton from "./ProductionAndSalesWithPaymentsGenericSkeleton";

function ProductionAndSalesWithPaymentsDetailSkeleton() {
  return (
    <>
      <ProductionAndSalesWithPaymentsGenericSkeleton />
    </>
  );
}

export default ProductionAndSalesWithPaymentsDetailSkeleton;
